// Mirrors quoting's pickup + delivery special instructions merge behavior.
// Idempotent: once delivery's text has been folded into pickup by a prior
// save, re-merging the same delivery text won't duplicate it.
export const formatSpecialInstructions = (
	pickupInstructions?: string | null,
	deliveryInstructions?: string | null,
): string => {
	const pickup = (pickupInstructions ?? "").trim();
	const delivery = (deliveryInstructions ?? "").trim();
	if (!delivery || pickup.includes(delivery)) {
		return pickup;
	}
	return [pickup, delivery].join("\n");
};
